module.exports = __webpack_public_path__ + "static/img/news2.2a0ed1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/news2.png
// module id = tfRb
// module chunks = 52